import {
  BanknotesIcon,
  CalculatorIcon,
  ClipboardDocumentListIcon,
  Cog8ToothIcon,
  RectangleStackIcon,
  ShoppingCartIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline';

import { routes } from '@config/routes';

interface SubMenuItem {
  subMenu: string;
  subMenuRoutes: string;
  matchRoutes?: string[];
}

interface MenuItem {
  icon: React.ElementType;
  mainMenu: string;
  subMenu?: SubMenuItem[];
  route?: string;
}

const createMatchRoutes = (basePath: string) => [
  basePath,
  `${basePath}/create`,
];

export const Menus: MenuItem[] = [
  {
    icon: Squares2X2Icon,
    mainMenu: 'Dashboard',
    route: routes.HOME,
  },
  {
    icon: BanknotesIcon,
    mainMenu: 'Revenue and Collections',
    subMenu: [
      {
        subMenu: 'Estimates and Quotes',
        subMenuRoutes: routes.RNC_ESTIMATES,
        matchRoutes: createMatchRoutes(routes.RNC_ESTIMATES),
      },
      {
        subMenu: 'Recurring Invoices',
        subMenuRoutes: routes.RNC_RECURRING_INVOICES,
        matchRoutes: createMatchRoutes(routes.RNC_RECURRING_INVOICES),
      },
      {
        subMenu: 'Invoices',
        subMenuRoutes: routes.RNC_INVOICES,
        matchRoutes: createMatchRoutes(routes.RNC_INVOICES),
      },
      {
        subMenu: 'Customers',
        subMenuRoutes: routes.RNC_CUSTOMERS,
        matchRoutes: createMatchRoutes(routes.RNC_CUSTOMERS),
      },
    ],
  },
  {
    icon: RectangleStackIcon,
    mainMenu: 'Inventory',
    subMenu: [
      {
        subMenu: 'Category',
        subMenuRoutes: routes.CATEGORIES,
      },
      {
        subMenu: 'Products and Services',
        subMenuRoutes: routes.INVENTORY_PRODUCTS,
      },
    ],
  },
  {
    icon: ShoppingCartIcon,
    mainMenu: 'Purchase and Payments',
  },
  {
    icon: CalculatorIcon,
    mainMenu: 'Accounting',
    subMenu: [
      {
        subMenu: 'Chart of Accounts',
        subMenuRoutes: routes.CHARTOFACCOUNTS,
      },
    ],
  },
  {
    icon: ClipboardDocumentListIcon,
    mainMenu: 'Reports',
    subMenu: [
      {
        subMenu: 'Aged Receivables',
        subMenuRoutes: routes.RPT_AGEDRECEIVABLES,
      },
      {
        subMenu: 'Income by Customer',
        subMenuRoutes: routes.RPT_INCOMEBYCUSTOMER,
      },
      {
        subMenu: 'Income by Category',
        subMenuRoutes: routes.RPT_INCOMEBYCATEGORY,
      },
      {
        subMenu: 'Sales Tax Report',
        subMenuRoutes: routes.RPT_SALESTAXREPORT,
      },
    ],
  },
  {
    icon: Cog8ToothIcon,
    mainMenu: 'Settings',
    subMenu: [
      {
        subMenu: 'Sales Tax',
        subMenuRoutes: routes.SALES_TAX,
      },
    ],
  },
];

export const getActiveMenuByRoute = (path: string) => {
  for (const menu of Menus) {
    const menuKey = menu.mainMenu.replace(/\s+/g, '-').toLowerCase();

    if (menu.route && path === menu.route) {
      return { activeMenu: menuKey, activeSubMenu: false };
    }

    if (menu.subMenu) {
      for (const sub of menu.subMenu) {
        const isExactMatch = path === sub.subMenuRoutes;
        const isChildRoute =
          sub.matchRoutes?.some((route) => path === route) ||
          path.startsWith(sub.subMenuRoutes);

        if (isExactMatch || isChildRoute) {
          const subMenuKey = sub.subMenu.replace(/\s+/g, '-').toLowerCase();
          return { activeMenu: menuKey, activeSubMenu: subMenuKey };
        }
      }
    }
  }

  return { activeMenu: null, activeSubMenu: false };
};
